import axios from "axios";
import { baseUrl } from "../util";

const authHeaders = () => ({
  headers: {
    Authorization: `Bearer ${localStorage.getItem("access_token")}`,
  },
});

export const fetchStorageUsage = async () => {
  try {
    const response = await axios.get(
      `${baseUrl}/api/accounts/storage/usage/`,
      authHeaders()
    );
    return response.data;
  } catch (error) {
    console.error("Failed to fetch storage usage:", error);
    throw error.response?.data || error;
  }
};

export const fetchUserStorageUsage = async (userId) => {
  if (!userId) throw new Error("userId is required");

  try {
    const response = await axios.get(
      `${baseUrl}/api/accounts/storage/usage/${userId}/`,
      authHeaders()
    );
    return response.data;
  } catch (error) {
    console.error("Failed to fetch user storage usage:", error);
    throw error.response?.data || error;
  }
};

export const purchaseStorageAddon = async (payload) => {
  try {
    const response = await axios.post(
      `${baseUrl}/api/accounts/storage/purchase/`,
      payload,
      authHeaders()
    );
    return response.data;
  } catch (error) {
    console.error("Failed to purchase storage add-on:", error);
    throw error.response?.data || error;
  }
};

export default {
  fetchStorageUsage,
  fetchUserStorageUsage,
  purchaseStorageAddon,
};











